import {Event} from "@/enums/Event";
import {Step} from "@/enums/Step";

export default {
  [Event.LIVESTREAM]: [Step.LOCATION_FORM,Step.MEMBER_FORM,Step.BILLING_FORM],
  [Event.LIVE]: [Step.MEMBER_FORM,Step.BILLING_FORM]
}
